/*
 * Easy Fenua - Produits complementaires (cross-sell), v3 (15/09)
 *
 * 1. Charge les produits recommandes en Ajax depuis /recommendations/products
 * 2. Gere les interrupteurs on/off
 * 3. Ajoute les produits coches au panier en meme temps que le produit principal
 *
 * Important : ce script n'intercepte PAS le clic sur "Ajouter au panier".
 * Il laisse le theme faire son travail normalement (et n'interfere donc pas
 * avec EasySell COD ni les autres apps), puis ajoute les extras en parallele
 * et rafraichit le panier.
 *
 * /!\ CE SCRIPT NE DEPLACE PLUS LE BLOC (v2). Il avait une fonction
 * placeAfterQuantity() qui le glissait a l'interieur du <form>, juste apres la
 * quantite. C'etait la DERNIERE cause des disparitions au changement de
 * declinaison : le theme refabrique la colonne a partir du HTML du serveur
 * (morph d'Alpine), et tout element qu'on a deplace ne correspond plus au sien.
 * Il a successivement supprime notre bouton, puis le formulaire entier.
 * La place du bloc est desormais donnee par le serveur, dans `block_order`
 * (templates/product.json) : il est rendu APRES cod_form, donc sous la carte
 * d'achat -- ce que Nathan demandait ("je ne veux pas les suggestions dans le
 * bloc noir").
 * /!\ SI LE BLOC REVIENT AU MAUVAIS ENDROIT, C'EST `block_order` QU'IL FAUT
 * CORRIGER, PAS UN DEPLACEMENT A REMETTRE ICI.
 *
 * A noter : le bloc n'a jamais eu besoin d'etre dans le <form>. Il ne contient
 * aucun champ de formulaire (des liens et des boutons type="button" lus via
 * leurs attributs data-), et addExtras() poste les extras lui-meme sur
 * /cart/add.js.
 *
 * /!\ ET ON N'ACCROCHE PLUS D'ECOUTEUR SUR LE BOUTON "Ajouter au panier" (v3) :
 * a chaque changement de declinaison le theme le REFABRIQUE, et l'ecouteur pose
 * sur l'ancien bouton partait avec lui -- les extras cessaient d'etre ajoutes
 * apres la premiere declinaison, sans rien afficher d'anormal. On ecoute le
 * clic sur le document, une fois pour toutes, et on retrouve le bouton au
 * moment du clic.
 */
(function () {
  'use strict';

  var CART_ROUTE = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';

  function loadList(listEl) {
    var root = listEl.closest('[data-cross-sell-root]');

    fetch(listEl.getAttribute('data-url'))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var fresh = document.createElement('div');
        fresh.innerHTML = html;

        var content = fresh.querySelector('[data-api-content]');
        if (!content || content.innerHTML.trim() === '') return;

        listEl.innerHTML = content.innerHTML;
        if (root) root.classList.remove('js-unloaded');
      })
      .catch(function (e) {
        console.warn('[cross-sell] chargement impossible', e);
      });
  }

  function selectedItems(root) {
    var items = [];
    root.querySelectorAll('[data-cross-sell-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-cross-sell-toggle]');
      if (toggle && toggle.getAttribute('aria-pressed') === 'true') {
        items.push({ id: item.getAttribute('data-variant-id'), quantity: 1 });
      }
    });
    return items;
  }

  function addExtras(root) {
    var items = selectedItems(root);
    if (!items.length) return;

    fetch(CART_ROUTE + '/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        // Remet les interrupteurs a zero et rafraichit le panier du theme
        root.querySelectorAll('[data-cross-sell-toggle]').forEach(function (btn) {
          btn.setAttribute('aria-pressed', 'false');
        });
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function (e) {
        console.warn('[cross-sell] ajout des extras impossible', e);
      });
  }

  // Les interrupteurs et le bouton d'ajout sont ecoutes depuis le document :
  // ils peuvent etre refabriques a tout moment par le theme.
  document.addEventListener('click', function (evt) {
    var toggle = evt.target.closest && evt.target.closest('[data-cross-sell-toggle]');
    if (toggle) {
      evt.preventDefault();
      toggle.setAttribute('aria-pressed', toggle.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      return;
    }

    var ajout = evt.target.closest && evt.target.closest('[data-add-to-cart]');
    if (!ajout || ajout.closest('[data-cross-sell-root]')) return;

    var section = ajout.closest('[data-section-type="product"]');
    var root = section && section.querySelector('[data-cross-sell-root]');
    if (!root) return;

    // Laisse le theme ajouter le produit principal, puis ajoute les extras
    setTimeout(function () { addExtras(root); }, 400);
  });

  function init() {
    document.querySelectorAll('[data-cross-sell-list]').forEach(function (listEl) {
      if (listEl.getAttribute('data-cross-sell-ready') === 'true') return;
      listEl.setAttribute('data-cross-sell-ready', 'true');
      loadList(listEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init apres un rechargement de section dans l'editeur de theme
  document.addEventListener('shopify:section:load', init);
})();
